import React from "react";
import { Connections } from "@hotglue/widget";
import { useQuickBooksConnection } from "../../../hooks/useQuickBooksConnection";

interface QuickBooksConnectionProps {
  intacctId?: string;
}

const QuickBooksConnection: React.FC<QuickBooksConnectionProps> = ({
  intacctId,
}) => {
  useQuickBooksConnection(intacctId);

  if (!intacctId) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Loading connection information...
      </p>
    );
  }

  return (
    <div className="-mx-5 overflow-x-auto sm:mx-0">
      <Connections tenant={intacctId} />
    </div>
  );
};

export default QuickBooksConnection;
